<template>
	<div class=" investmentClues">
		<leftnav class="fl" mkcode="C"
			itemcode="C-RDCYQYPH"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox " style="padding-bottom: 5px;">
					<div class="right_boxtitle">
						<span class="fl right_title"
							v-if="curWebsite.type != 5 && curWebsite.type != 6">{{ curWebsite.keyword }}{{ curWebsite.type
								== 2 ? '' :'线索'}}</span>
						<span class="fl right_title" v-if="curWebsite.type == 5 || curWebsite.type == 6">产业排行榜</span>
						<cluetips></cluetips>
						<video-teaching :type="3" seat="top"></video-teaching>
					</div>
					<!-- 筛选项开始 -->
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<ClueNav tabCode="rdcyrdqy"></ClueNav>
						</div>
						<dl class="opport-screen bdbe">
							<dt class="fl">省份地区</dt>
							<dd class="fl">
								<span :class="provinceid == 0 ? 'current a-screen' : 'a-screen'"
									@click="provincechoose(0, 'all'); ">全国地区</span>
								<span v-for="(item, index) in provincedata" :key="item.areaName + index"
									@click="provincechoose(item.areaId, index); "
									:class="item.areaId == provinceid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="citydata.length > 0">
							<dt class="fl">城市地区</dt>
							<dd class="fl">
								<span :class="cityid == 0 ? 'current a-screen' : 'a-screen'"
									@click="choosecity(0, 'all');">全部</span>
								<span v-for="(item, index) in citydata" :key="item.areaName + index"
									@click="choosecity(item.areaId, index); cityid = item.areaId;"
									:data="item.areaId"
									:class="item.areaId == cityid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">热点产业</dt>
							<dd class="fl">
								<span :class="temNcode1 == 0 ? 'a-screen current' : 'a-screen'"
									@click="notionclick(1, { value: 0, label: '全部', children: [] })">全部</span>
								<span v-for="(item, i) in notionlist" :key="'notion' + i"
									:class="temNcode1 == item.value ? 'a-screen current' : 'a-screen'"
									@click="notionclick(1, item)">{{ item.label }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="smnotionlist.length > 0">
							<dt class="fl">细分产业</dt>
							<dd class="fl">
								<span :class="temNcode2 == temNcode1 ? 'a-screen current' : 'a-screen'"
									@click="notionclick(2, { value: temNcode1, label: '全部', children: [] })">全部</span>
								<span v-for="(item, i) in smnotionlist" :key="'tag' + i"
									:class="temNcode2 == item.value ? 'a-screen current' : 'a-screen'"
									@click="notionclick(2, item)">{{ item.label }}</span>
							</dd>
						</dl>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 表格内容开始 -->
				<div class="whitebox columnbox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<!-- 多维度分数筛选 -->
					<ul class="dimensionScreen oh w95mg">
						<li :class="orderField == list.type ? 'fl current ' : 'fl '" v-for="(list, index) in dimensionList"
							:key="'sort' + index" @click="tablesort(list.type);"><span
								:class="{ 'sortname ': true, 'current': orderField == list.type, 'fz15': list.name.length > 5 }">{{ list.name }}</span><span
								:class="orderType == 1 ? 'timesorticon up' : 'timesorticon down'"></span></li>
					</ul>
					<!-- 热门产业全部企业 -->
					<div class="enterprise_list_box" v-show="enterpristlist.length != 0">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>投资力度</th>
								<th>编辑</th>
							</tr>
							<tr v-for="(list, index) in enterpristlist" :key="list.title + index">
								<td>{{ (page - 1) * pageSize + index + 1 }}</td>
								<td class="title" @click="routerlinkid('/enterprises', list.stockCode, 9, '', curindex)">
									{{ list.title }}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.notionlist" :key="item.id"
										@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name, 'all')">{{ item.name }}</span>
								</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.taglist" :key="item.id"
										@click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name, 'all')">{{ item.name }}</span>
								</td>
								<td>{{ list.area }}</td>
								<td>{{ list.zs100000 }}</td>
								<td>{{ list.zs200000 }}</td>
								<td class="collectfont1"><span @click="listToggleCollect(list)">{{ list.collectId ==
									0 ?'加入':'移除'}}<br />目标企业</span></td>
							</tr>
						</table>
					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { dataInJs } from "../../utils/city.js";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'investmentClues5',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title:'热点产业企业排行',
			total1: 0,
			pro: 0,
			userdata: {}, curWebsite: this.$api.getWebsiteType(),
			searchtype: 4,//线索类型 2以商招商 1本省投资概率 3关键融资 4优质企业 5热点产业企业 
			provincedata: [],
			countydata: [],
			citydata: [],
			provinceid: 0,
			// notionCodearr:[{code:'A0101'},{'A0201'},{'A0301'},{'A0501'},{'A0502'},{'C01'},{'A0308'},{'A0313'},{'A0317'},{'A0504'},{'A0601'}],
			notionlist: [],//全部概念数据
			smnotionlist: [],//细分概念数据
			notionCodearr: ['A0101', 'A0201', 'A0301', 'A0501', 'A0502', 'C01', 'A0308', 'A0313', 'A0317', 'A0504', 'A0601'],
			notionTextarr: ['新能源汽车', '半导体', '机器人', '氢能源', '光伏', '风电', '人工智能', '大数据', '网络信息安全', '储能', '医药制造'],
			notionCode: 'A0101,A0201,A0301,A0501,A0502,C01,A0308,A0313,A0317,A0504,A0601', notionText: "", temNcode2: 0, temNcode1: 0, temNtext: 0,
			cityid: 0,
			countyid: 0,
			enterpristlist: [],
			page: 1,  //显示的是哪一页
			haspage: true,//是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数 
			totalPage: 1,
			maxPage: 10,  //最大页数  
			areadata: dataInJs(), //省份城市数据
			orderField: 0,//排序字段 0 分数 1 时间
			orderType: 0,//排序方式 0 降序 1 升序 
			// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
			dimensionList: [{ name: '综合', type: 0 }, { name: '企业实力', type: 2 }, { name: '投资力度', type: 3 }, { name: '本省关联度', type: 4 }, { name: '拿地数量', type: 5 }, { name: '拿地面积', type: 6 }, { name: '拿地金额', type: 7 }, { name: '投资项目数量', type: 8 }, { name: '投资项目金额', type: 9 }],
			// ,{name:'控制企业数量',type:10},{name:'专利数量',type:11},
			isShowFreeUserTips: false,
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this;
		this.userdata = this.getuseriformation();
		_this.provincedata = this.areadata;
		_this.getnotionList();
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		this.gethotenterpriseList();
	},
	methods: {
		//分析判断获取热点产业和细分产业
		getnotionList() {
			
			var notionja = this.notionCodearr.join(','), _this = this;
			this.$axios.get(this.$api.tag.notion.detail() + '?notionCode=' + notionja).then(function (res) {
				if (res.data.success) {
					var ddds = [];
					// console.log(res.data)  
					_this.notionlist = res.data.list;
					console.log(_this.notionlist);
				} else {

				}
			});
		},
		notionclick(step, data) {
			console.log(data, step);
			this.isShowFreeUserTips = true;
			return;
			if (step == 1) {
				var delatetext = '&A020113&A020114&A020115&A020116&A020117&A020118&', data1 = data.children;
				if (data.label == '新能源汽车') {
					data1 = data.children.filter(list => {
						return delatetext.indexOf(list.value + '&') < 1;
					})
				}
				this.smnotionlist = data1;
				this.temNcode1 = data.value;
			};
			if (data.value == 0) {
				this.notionCode = this.notionCodearr.join(',');
			} else {
				this.notionCode = data.value;
			}
			this.temNcode2 = data.value;
			this.notionText = data.label;
			this.gethotenterpriseList();
		},
		//省份城市选择
		provincechoose(id, i) {
			this.isShowFreeUserTips = true;
			return;
			this.provinceid = id; this.cityid = 0;
			if (i != "all" && this.provincedata[i].children != null) {
				this.citydata = this.provincedata[i].children;
			} else {
				this.citydata = [];
			}
			this.gethotenterpriseList();
		},
		choosecity(id, i) {
			//	console.log('choosecity',id);
			this.cityid = id;
			this.gethotenterpriseList();
		},
		// pageHandler: function (page) {
		// 	this.page = page; 
		// 	this.gethotenterpriseList(page); 
		// },
		pageHandler: function (page) {
			if(page>1){
				this.isShowFreeUserTips = true;
				return;
			}
			this.gethotenterpriseList(page);
		},
		//时间/分数升降序
		tablesort(field) {
			this.isShowFreeUserTips = true;
				return;
			if (field == this.orderField) {
				this.orderType = Math.abs(this.orderType - 1);
			} else {
				this.orderField = field;
			}
			this.gethotenterpriseList();
		},
		gethotenterpriseList(page) {
			this.bus.$emit('loading', true);
			// console.log('gethotenterpriseList');
			this.page = page ? page : 1;
			var _this = this;
			//获取企业列表
			var notionja = this.splicing('notion', this.notionCode);
			var provinceja = this.splicing('province', this.provinceid);
			var cityja = this.splicing('city', this.cityid);
			var ajaxurl = this.$api.free.investclue.hotspot();
			console.log(ajaxurl);
			this.$axios.get(ajaxurl).then(function (res) {
				// console.log('省份城市列表',res.data)
				if (res.data.success) {
					console.log('获取企业列表', res.data.list);
					_this.enterpristlist = res.data.list;
					for (var i = 0; i < res.data.list.length; i++) {
						_this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this.enterpristlist[i].tagCode);
						_this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion, _this.enterpristlist[i].notionCode);
					}

					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.haspage = res.data.list.length == res.data.pageSize;
					_this.kwtextsearch = _this.searchtext != ''
					_this.kwtextsearchtext = _this.searchtext;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});


		},
		jsondouhao(name, data) {
			if (data.length > 0) {
				var notionja = "";
				if (data.length != 0) {
					var douhao = '%2C';
					for (var i = 0; i < data.length; i++) {
						if (i == data.length - 1) {
							douhao = '';
						}
						notionja += data[i].id + douhao;
					}
					notionja = '&' + name + '=' + notionja;
					return notionja;
				}
			} else {
				return "";
			}
		},
	},
}
</script>

<style>
/* 提示框箭头 */
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
	border-top-color: #E0E8F9;
}

.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
	border-top-color: #E0E8F9;
}

/* 提示框背景色 */
.atooltip {
	background: #E0E8F9 !important;
}
</style>
